import {connect} from 'react-redux';
import {getPharmacies} from 'reducers/pharmacies/pharmaciesActions';
import PharmacyField from './PharmacyField';

const mapStateToProps = (state) => {
    const props = {...state.pharmacies}
    const {dropdownList} = state.pharmacies

    if (dropdownList) {
        props.dropdownList = dropdownList.list;
        props.totalCount = dropdownList.totalCount;
    }

    return props;
}

const mapDispatchToProps = {
    onSearch: getPharmacies,
};

export default connect(mapStateToProps, mapDispatchToProps)(PharmacyField);



// WEBPACK FOOTER //
// ./src/components/controls/PharmacyFieldContainer.js